// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AuctionPaddleUser } from './auction-paddle-user';
import { InvoiceLine } from './invoice-line';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Invoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get totalCalc() {
        let subTotal = 0;
        this.invoiceLines.forEach((line) => {
            if (!line.deleted) {
                subTotal += line.quantity * line.price;
            }
        });
        return subTotal;
    }
    get subTotal() {
        return this.totalCalc;
    }

    get donationTotal() {
        let donationTotal = 0;
        this.invoiceLines.forEach((line) => {
            if (!line.deleted && line.isDonationQualified) {
                donationTotal += line.quantity * line.price;
            }
        });
        return donationTotal;
    }

    get balance() {
        return this.total - this.paidAmount;
    }

    get isPaid() {
        return !!this.paid;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address?: string;
  auctionPaddleUserId?: number;
  checkNumber?: string;
  city?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  invoiceDate!: Date;
  invoiceNumber!: number;
  name?: string;
  notes?: string;
  paid?: Date;
  paidAmount?: number;
  paymentMethod?: string;
  personId?: number;
  phone?: string;
  state?: string;
  total!: number;
  zip?: string;
  auctionPaddleUser!: AuctionPaddleUser;
  invoiceLines!: InvoiceLine[];
  person!: Person;
}

